(function(){
  'use strict';

  function cleanText(value){
    return (value || '').replace(/\s+/g,' ').trim().toLocaleLowerCase('tr-TR');
  }

  function sizeKeyFromText(value){
    var text = cleanText(value)
      .replace(/plus/g,'+')
      .replace(/\s/g,'');
    if(text.indexOf('a3+') > -1) return 'a3plus';
    if(text.indexOf('a1') > -1) return 'a1';
    if(text.indexOf('a2') > -1) return 'a2';
    if(text.indexOf('a3') > -1) return 'a3';
    return '';
  }

  var wallSizes = {
    a3:     {label:'A3',      dims:'33 × 45 cm', scale:.78},
    a3plus: {label:'A3 Plus', dims:'35 × 48 cm', scale:.84},
    a2:     {label:'A2',      dims:'45 × 63 cm', scale:.94},
    a1:     {label:'A1',      dims:'63 × 87 cm', scale:1.08}
  };

  var sixA3PlusHandles = {
    'formula-yaris-temali-6-li-a3-duvar-tablosu-seti-dogal-ahsap-cerceveli-motorsport-yaris-arabasi-duvar-dekoru': true,
    'savas-ucagi-ve-pilot-temali-6-li-a3-duvar-tablosu-seti-dogal-ahsap-cerceveli-havacilik-duvar-dekoru': true,
    '6-parcali-astronot-uzay-duvar-tablosu-seti-gamer-genc-odasi-dekoru-siyah-cam-ahsap-cerceveli-a3-tablo': true,
    'western-kovboy-6-li-a3-duvar-tablosu-seti-dogal-ahsap-cerceveli-vintage-wild-west-duvar-dekoru': true,
    '6-parcali-viking-duvar-tablosu-seti-iskandinav-mitolojisi-valhalla-temali-cerceveli-a3-duvar-dekoru': true,
    'tokyo-street-6-li-japon-temali-tablo-seti-a3-japonya-araba-sneaker-duvar-dekoru': true,
    '6-li-orta-cag-sovalye-tablo-seti-a3-gotik-kale-erkek-odasi-duvar-dekoru': true,
    'tokyo-racing-6-li-a3-cerceveli-tablo-seti-japon-araba-jdm-tarzi-duvar-dekoru': true,
    '6-li-japon-samuray-tablo-seti-a3-katana-japon-sanati-duvar-dekoru': true,
    'iconic-legends-6-li-a3-cerceveli-tablo-seti-sinematik-karakter-duvar-dekoru': true
  };

  function escapeHtml(value){
    return String(value || '')
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#039;');
  }

  function parseSizeOption(value){
    var raw = String(value || '').replace(/\s+/g,' ').trim();
    var match = raw.match(/^(.*?)\s*\(([^)]+)\)\s*$/);
    return {
      raw: raw,
      label: match ? match[1].trim() : raw,
      dims: match ? match[2].trim() : ''
    };
  }

  function getSizeOptions(fieldset){
    if(!fieldset) return [];
    var seen = {};
    var options = [];

    fieldset.querySelectorAll('input[type="radio"]').forEach(function(input){
      var raw = input.value || input.getAttribute('value') || '';
      var key = sizeKeyFromText(raw);
      if(!key || seen[key]) return;
      seen[key] = true;
      var parsed = parseSizeOption(raw);
      options.push({
        key:key,
        raw:parsed.raw,
        label:parsed.label,
        dims:parsed.dims,
        input:input
      });
    });

    return options;
  }

  function getSizeOptionData(fieldset,key){
    var options = getSizeOptions(fieldset);
    for(var i=0;i<options.length;i++){
      if(options[i].key === key) return options[i];
    }
    var fallback = wallSizes[key] || wallSizes.a3plus;
    return {
      key:key,
      label:fallback.label,
      dims:fallback.dims,
      raw:fallback.label+' ('+fallback.dims+')',
      input:null
    };
  }

  function selectedSizeKey(fieldset){
    if(!fieldset) return '';
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    return checked ? sizeKeyFromText(checked.value || checked.getAttribute('value') || '') : '';
  }

  function parseRatio(dims){
    var nums = String(dims || '').replace(',','.').match(/\d+(?:\.\d+)?/g);
    if(!nums || nums.length < 2) return 35/48;
    var w = parseFloat(nums[0]);
    var h = parseFloat(nums[1]);
    return w && h ? w / h : 35/48;
  }

  function fixedDimsFromTags(tags,mode){
    var match = String(tags || '').match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
    if(match){
      return match[1].replace(',','.')+' × '+match[2].replace(',','.')+' cm';
    }
    return mode === 'grid9' ? '36 × 51 cm' : '33 × 48 cm';
  }

  function normalizeSetText(value){
    return String(value || '')
      .toLocaleLowerCase('tr-TR')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g,'')
      .replace(/ı/g,'i');
  }

  function inferSetCount(meta){
    if(!meta) return 1;
    var text = normalizeSetText([
      meta.getAttribute('data-product-title') || '',
      meta.getAttribute('data-product-type') || '',
      meta.getAttribute('data-product-tags') || ''
    ].join(' '));

    if(/9\s*(parcali|li)|dokuzlu/.test(text)) return 9;
    if(/8\s*(parcali|li)|sekizli/.test(text)) return 8;
    if(/6\s*(parcali|li)|altili/.test(text)) return 6;
    if(/4\s*(parcali|li)|dortlu/.test(text)) return 4;
    if(/3\s*(parcali|li)|uclu/.test(text)) return 3;
    if(/ikili|2\s*(parcali|li)|\bduo\b|\bdual\b/.test(text)) return 2;

    var fallback = parseInt(meta.getAttribute('data-set-count') || '1',10);
    return fallback || 1;
  }

  function getWallMode(count,handle){
    if(count >= 1 && count <= 4) return 'standard';
    if(count === 6 && sixA3PlusHandles[handle]) return 'grid6';
    if(count === 9) return 'grid9';
    return 'none';
  }

  function standardLayout(count){
    if(count === 2) return [[28,18,18],[55,18,18]];
    if(count === 3) return [[15,18,17],[41.5,18,17],[68,18,17]];
    if(count === 4) return [[27,8,15],[58,8,15],[27,52,15],[58,52,15]];
    return [[40,10,20]];
  }

  function buildFrames(mode,count,dims){
    var ratio = parseRatio(dims);

    if(mode === 'grid6' || mode === 'grid9'){
      var total = mode === 'grid6' ? 6 : 9;
      var html = '';
      for(var i=0;i<total;i++){
        html += '<span class="bd-wall-stage__frame bd-wall-stage__frame--grid" style="--frame-ratio:'+ratio+'" aria-hidden="true"><i></i></span>';
      }
      return html;
    }

    return standardLayout(count).map(function(frame){
      return '<span class="bd-wall-stage__frame bd-wall-stage__frame--equal" style="--x:'+frame[0]+'%;--y:'+frame[1]+'%;--w:'+frame[2]+'%;--frame-ratio:'+ratio+'" aria-hidden="true"><i></i></span>';
    }).join('');
  }

  function buildSizeButtons(fieldset){
    return getSizeOptions(fieldset).map(function(option){
      return '<button type="button" data-wall-size-key="'+escapeHtml(option.key)+'">'+
        '<strong>'+escapeHtml(option.label)+'</strong>'+
        (option.dims ? '<span>'+escapeHtml(option.dims)+'</span>' : '')+
      '</button>';
    }).join('');
  }

  function renderWallTool(fieldset,tool,forcedKey){
    if(!tool) return;

    var count = parseInt(tool.getAttribute('data-set-count') || '1',10);
    var handle = tool.getAttribute('data-product-handle') || '';
    var mode = getWallMode(count,handle);
    if(mode === 'none') return;

    var options = getSizeOptions(fieldset);
    var hasSizes = mode === 'standard' && options.length > 0;
    var key = hasSizes ? (forcedKey || selectedSizeKey(fieldset) || options[0].key) : '';
    var exact = hasSizes ? getSizeOptionData(fieldset,key) : null;
    var fallback = key ? (wallSizes[key] || wallSizes.a3plus) : wallSizes.a3plus;
    var fixedDims = tool.getAttribute('data-fixed-dims') || (mode === 'grid9' ? '36 × 51 cm' : '33 × 48 cm');

    if(mode === 'standard' && hasSizes){
      tool.setAttribute('data-current-size',key);
      tool.style.setProperty('--bd-set-scale',fallback.scale || .84);
      tool.querySelectorAll('[data-wall-size]').forEach(function(node){ node.textContent = exact.label; });
      tool.querySelectorAll('[data-wall-dims]').forEach(function(node){ node.textContent = exact.dims; });
      tool.querySelectorAll('[data-wall-full-option]').forEach(function(node){ node.textContent = exact.raw; });
    } else if(mode === 'standard'){
      tool.style.setProperty('--bd-set-scale','.84');
      tool.querySelectorAll('[data-wall-size]').forEach(function(node){ node.textContent = 'Sabit düzen'; });
      tool.querySelectorAll('[data-wall-dims]').forEach(function(node){ node.textContent = ''; });
      tool.querySelectorAll('[data-wall-full-option]').forEach(function(node){ node.textContent = ''; });
    } else {
      tool.style.setProperty('--bd-set-scale','1');
      tool.querySelectorAll('[data-wall-size]').forEach(function(node){ node.textContent = 'A3 Plus'; });
      tool.querySelectorAll('[data-wall-dims]').forEach(function(node){ node.textContent = fixedDims; });
      tool.querySelectorAll('[data-wall-full-option]').forEach(function(node){
        node.textContent = mode === 'grid6'
          ? '6 adet eşit A3 Plus · 3 + 3 düzen'
          : '9 adet eşit A3 Plus · 3 + 3 + 3 düzen';
      });
    }

    tool.querySelectorAll('[data-wall-count]').forEach(function(node){
      node.textContent = count === 1 ? 'TEKLİ ESER' : count+' PARÇALI SET';
    });

    var group = tool.querySelector('[data-wall-frame-group]');
    if(group){
      group.className = 'bd-wall-stage__frames bd-wall-stage__frames--'+mode;
      group.innerHTML = buildFrames(
        mode,
        count,
        exact ? exact.dims : (mode === 'standard' ? wallSizes.a3plus.dims : fixedDims)
      );
    }

    tool.querySelectorAll('[data-wall-size-key]').forEach(function(button){
      button.classList.toggle('is-active',button.getAttribute('data-wall-size-key') === key);
    });
  }

  function createWallModal(fieldset,meta){
    var old = document.querySelector('.bd-wall-modal');
    if(old) old.remove();

    if(!meta) return null;

    var count = inferSetCount(meta);
    var handle = meta.getAttribute('data-product-handle') || '';
    var title = meta.getAttribute('data-product-title') || '';
    var tags = meta.getAttribute('data-product-tags') || '';
    var mode = getWallMode(count,handle);
    var fixedDims = fixedDimsFromTags(tags,mode);

    if(mode === 'none') return null;

    var hasSizes = mode === 'standard' && getSizeOptions(fieldset).length > 0;

    var modal = document.createElement('div');
    modal.className = 'bd-wall-modal bd-wall-modal--'+mode;
    modal.setAttribute('aria-hidden','true');
    modal.setAttribute('data-set-count',count);
    modal.setAttribute('data-product-handle',handle);
    modal.setAttribute('data-fixed-dims',fixedDims);

    var sizeBlock;
    if(hasSizes){
      sizeBlock =
        '<span class="bd-wall-modal__kicker">SEÇİLİ BOYUT</span>'+
        '<div class="bd-wall-modal__selected"><strong data-wall-size></strong><em data-wall-dims></em></div>'+
        '<p class="bd-wall-modal__exact" data-wall-full-option></p>'+
        '<div class="bd-wall-modal__sizes">'+buildSizeButtons(fieldset)+'</div>';
    } else if(mode === 'grid6' || mode === 'grid9'){
      sizeBlock =
        '<span class="bd-wall-modal__kicker">SET DÜZENİ</span>'+
        '<div class="bd-wall-modal__selected"><strong data-wall-size>A3 Plus</strong><em data-wall-dims>'+escapeHtml(fixedDims)+'</em></div>'+
        '<p class="bd-wall-modal__exact" data-wall-full-option></p>';
    } else {
      sizeBlock =
        '<span class="bd-wall-modal__kicker">SET DÜZENİ</span>'+
        '<div class="bd-wall-modal__selected"><strong data-wall-size>Sabit düzen</strong></div>';
    }

    modal.innerHTML =
      '<div class="bd-wall-modal__backdrop" data-wall-close></div>'+
      '<div class="bd-wall-modal__dialog" role="dialog" aria-modal="true" aria-label="Duvarda Gör">'+
        '<button type="button" class="bd-wall-modal__close" data-wall-close aria-label="Kapat">×</button>'+
        '<div class="bd-wall-modal__head">'+
          '<span>DUVARDA GÖR</span>'+
          '<h2>Duvarındaki oranı gör.</h2>'+
          '<p>Önizleme yalnızca çerçeve adedini, oranını ve yaklaşık duvar ölçeğini gösterir.</p>'+
        '</div>'+
        '<div class="bd-wall-modal__body">'+
          '<div class="bd-wall-stage">'+
            '<div class="bd-wall-stage__label"><span data-wall-count></span><b data-wall-dims></b></div>'+
            '<div class="bd-wall-stage__frames" data-wall-frame-group></div>'+
            '<div class="bd-wall-stage__furniture">'+
              '<div class="bd-wall-stage__lamp"><i></i><b></b></div>'+
              '<div class="bd-wall-stage__side-table"><i></i></div>'+
              '<div class="bd-wall-stage__sofa"><span class="arm arm--l"></span><span class="arm arm--r"></span><i></i><i></i><i></i></div>'+
              '<div class="bd-wall-stage__measure"><span></span><b>180 cm koltuk referansı</b><span></span></div>'+
            '</div>'+
            '<div class="bd-wall-stage__floor"></div>'+
          '</div>'+
          '<aside class="bd-wall-modal__panel">'+sizeBlock+
            '<div class="bd-wall-modal__foot"><span>Yaklaşık yerleşim</span><b>'+escapeHtml(title)+'</b></div>'+
          '</aside>'+
        '</div>'+
      '</div>';

    document.body.appendChild(modal);

    modal.querySelectorAll('[data-wall-close]').forEach(function(btn){
      btn.addEventListener('click',function(){ closeWallModal(modal); });
    });

    modal.querySelectorAll('[data-wall-size-key]').forEach(function(button){
      button.addEventListener('click',function(){
        var key = button.getAttribute('data-wall-size-key');
        var option = getSizeOptionData(fieldset,key);
        if(option && option.input){
          option.input.checked = true;
          option.input.dispatchEvent(new Event('input',{bubbles:true}));
          option.input.dispatchEvent(new Event('change',{bubbles:true}));
        }
        renderWallTool(fieldset,modal,key);
      });
    });

    if(fieldset){
      fieldset.addEventListener('change',function(){
        renderWallTool(fieldset,modal);
      });
    }

    document.addEventListener('keydown',function wallEsc(e){
      if(e.key === 'Escape' && modal.classList.contains('is-open')) closeWallModal(modal);
    });

    renderWallTool(fieldset,modal);
    return modal;
  }

  function openWallModal(modal){
    if(!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('bd-wall-modal-open');
    document.body.classList.add('bd-wall-modal-open');
  }

  function closeWallModal(modal){
    if(!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('bd-wall-modal-open');
    document.body.classList.remove('bd-wall-modal-open');
  }

  function decorateHeader(){
    function onScroll(){
      document.body.classList.toggle('bd-header-scrolled', window.scrollY > 16);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, {passive:true});
  }

  function centerProductDescription(info){
    if(!info) return;

    var description = info.querySelector('.product__description');
    if(!description) return;

    var productGrid = info.closest('.product');
    if(!productGrid || !productGrid.parentNode) return;

    var parent = productGrid.parentNode;
    var stage = parent.querySelector('.bd-product-description-stage');

    if(!stage){
      stage = document.createElement('section');
      stage.className = 'bd-product-description-stage';
      stage.innerHTML = '<div class="bd-product-description-stage__inner"><div class="bd-product-description-stage__eyebrow">ESER DETAYI</div></div>';
      parent.insertBefore(stage, productGrid.nextSibling);
    }

    var inner = stage.querySelector('.bd-product-description-stage__inner');
    if(inner && description.parentNode !== inner){
      inner.appendChild(description);
    }
  }

  function decorateProduct(root){
    root = root || document;
    var info = root.querySelector('.product__info-container');
    var sizeFieldset = null;
    var productInfoRoot = info.closest('product-info') || root;
    var wallMeta = productInfoRoot.querySelector('[data-bd-wall-meta]');
    var wallTrigger = info.querySelector('[data-bd-wall-trigger]');
    if(!info) return;

    var title = info.querySelector('.product__title');
    if(title && !info.querySelector('.bd-product-eyebrow')){
      var eyebrow = document.createElement('div');
      eyebrow.className = 'bd-product-eyebrow';
      eyebrow.textContent = 'BOURDUA · ÇERÇEVELİ DUVAR SANATI';
      title.parentNode.insertBefore(eyebrow, title);
    }

    var fieldsets = info.querySelectorAll('.product-form__input');
    fieldsets.forEach(function(fieldset){
      var legend = fieldset.querySelector('.form__label');
      if(!legend) return;
      var name = cleanText(legend.childNodes[0] ? legend.childNodes[0].textContent : legend.textContent);

      if(name.indexOf('boyut') > -1 || name.indexOf('ölçü') > -1 || name.indexOf('size') > -1){
        sizeFieldset = fieldset;
        fieldset.classList.add('bd-option-size');

        var oldHelper = legend.querySelector('.bd-option-helper');
        if(oldHelper) oldHelper.remove();

        var oldToggle = legend.querySelector('.bd-size-guide-toggle');
        if(oldToggle) oldToggle.remove();

        var oldGuide = fieldset.nextElementSibling && fieldset.nextElementSibling.classList.contains('bd-size-guide')
          ? fieldset.nextElementSibling
          : null;
        if(oldGuide) oldGuide.remove();

      }

      if(name.indexOf('çerçeve rengi') > -1 || name === 'renk' || name.indexOf('frame color') > -1){
        fieldset.classList.add('bd-option-frame');
      }
    });


    centerProductDescription(info);

    if(wallTrigger){
      var previewCount = wallMeta ? inferSetCount(wallMeta) : 1;
      var previewHandle = wallMeta ? (wallMeta.getAttribute('data-product-handle') || '') : '';
      var previewMode = getWallMode(previewCount,previewHandle);

      if(previewMode === 'none'){
        wallTrigger.style.display = 'none';
      } else {
        wallTrigger.style.display = '';
        if(!wallTrigger.dataset.bound){
          wallTrigger.dataset.bound = 'true';
          var wallModal = createWallModal(sizeFieldset,wallMeta);
          wallTrigger.addEventListener('click',function(){
            renderWallTool(sizeFieldset,wallModal);
            openWallModal(wallModal);
          });
        }
      }
    }

    if(!info.querySelector('.bd-product-benefits')){
      var form = info.querySelector('product-form, .product-form');
      var benefits = document.createElement('div');
      benefits.className = 'bd-product-benefits';
      benefits.setAttribute('aria-label','Bourdua ürün özellikleri');
      benefits.innerHTML =
        '<div class="bd-product-benefit"><div><strong>Doğal ahşap</strong><span>Atölyede hazırlanır</span></div></div>'+
        '<div class="bd-product-benefit"><div><strong>Sanat baskısı</strong><span>Yüksek detay kalitesi</span></div></div>'+
        '<div class="bd-product-benefit"><div><strong>Siparişe özel</strong><span>Tek tek hazırlanır</span></div></div>'+
        '<div class="bd-product-benefit"><div><strong>Güvenli gönderim</strong><span>Korumalı paketleme</span></div></div>';

      if(form && form.parentNode){
        form.parentNode.insertBefore(benefits, form);
      } else {
        info.appendChild(benefits);
      }
    }
  }

  function addEditorialStrip(){
    var hero = document.querySelector('.bd-hero-final');
    if(!hero || document.querySelector('.bd-editorial-strip')) return;
    var section = hero.closest('.shopify-section') || hero.parentNode;
    if(!section || !section.parentNode) return;

    var strip = document.createElement('section');
    strip.className = 'bd-editorial-strip';
    strip.innerHTML =
      '<div class="bd-editorial-strip__inner">'+
        '<div class="bd-editorial-strip__item"><div class="bd-editorial-strip__kicker">MALZEME</div><div class="bd-editorial-strip__title">Doğal ahşap çerçeve</div><div class="bd-editorial-strip__text">Eseri tamamlayan sıcak ve zamansız bir çerçeve dili.</div></div>'+
        '<div class="bd-editorial-strip__item"><div class="bd-editorial-strip__kicker">BASKI</div><div class="bd-editorial-strip__title">Sanat baskısı kalitesi</div><div class="bd-editorial-strip__text">Detayı, tonu ve kompozisyonu koruyan yüksek çözünürlüklü üretim.</div></div>'+
        '<div class="bd-editorial-strip__item"><div class="bd-editorial-strip__kicker">ATÖLYE</div><div class="bd-editorial-strip__title">Siparişe özel hazırlanır</div><div class="bd-editorial-strip__text">Seri üretim hissinden uzak, atölye özeniyle tamamlanan eserler.</div></div>'+
      '</div>';
    section.parentNode.insertBefore(strip, section.nextSibling);
  }

  function run(){
    decorateProduct(document);
    addEditorialStrip();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){
      decorateHeader();
      run();
    });
  } else {
    decorateHeader();
    run();
  }

  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:select', run);

  var observer = new MutationObserver(function(mutations){
    var shouldRun = mutations.some(function(m){ return m.addedNodes && m.addedNodes.length; });
    if(shouldRun) decorateProduct(document);
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();